import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const EducationField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>Høyeste gjennomførte utdannelse</p>
    <Field name="highestEducation" type="radio" value="low">
      {({ input }) => (
        <label htmlFor="highestEducation_low">
          <Radio
            id="highestEducation_low"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Grunnskole
        </label>
      )}
    </Field>
    <Field name="highestEducation" type="radio" value="medium">
      {({ input }) => (
        <label htmlFor="highestEducation_medium">
          <Radio
            id="highestEducation_medium"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Videregående
        </label>
      )}
    </Field>
    <Field name="highestEducation" type="radio" value="high">
      {({ input }) => (
        <label htmlFor="highestEducation_high">
          <Radio
            id="highestEducation_high"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Høyskole/Universitet
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default EducationField;
